import React, { useState } from 'react';
import { Table, Badge, Collapse } from 'react-bootstrap';

// Types
import { IAuditLog } from './types';

type AuditTablePropsTypes = {
  data: IAuditLog[];
};

const actionBadgeVariant: Record<string, string> = {
  POST: 'success',
  PUT: 'warning',
  DELETE: 'danger'
};

const AuditTable = (props: AuditTablePropsTypes) => {
  const data = props.data ?? [];
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const toggleRow = (id: string) => {
    setExpandedRow(prev => (prev === id ? null : id));
  };

  const formatPayload = (payload: string): string => {
    try {
      return JSON.stringify(JSON.parse(payload), null, 2);
    } catch {
      return payload;
    }
  };

  return (
    <Table striped bordered hover responsive size="sm" className="fs-10 mb-0">
      <thead className="bg-200 text-nowrap align-middle">
        <tr>
          <th className="text-900 ps-3 py-2">Дата</th>
          <th className="text-900 ps-3 py-2">Действие</th>
          <th className="text-900 ps-3 py-2">Ресурс</th>
          <th className="text-900 ps-3 py-2">ID ресурса</th>
          <th className="text-900 ps-3 py-2">IP</th>
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={5} className="text-center py-4 text-muted">
              Нет данных
            </td>
          </tr>
        ) : (
          data.map(log => (
            <React.Fragment key={log.id}>
              <tr
                onClick={() => toggleRow(log.id)}
                style={{ cursor: 'pointer' }}
                title="Нажмите, чтобы показать payload"
              >
                <td className="ps-3 py-2">
                  {new Date(log.created_at).toLocaleString('ru-RU')}
                </td>
                <td className="ps-3 py-2">
                  <Badge
                    bg={actionBadgeVariant[log.action] || 'secondary'}
                    className="text-uppercase"
                  >
                    {log.action}
                  </Badge>
                </td>
                <td className="ps-3 py-2">{log.resource}</td>
                <td className="ps-3 py-2">
                  <span
                    className="text-truncate d-inline-block"
                    style={{ maxWidth: '200px' }}
                  >
                    {log.resource_id}
                  </span>
                </td>
                <td className="ps-3 py-2">{log.ip_address}</td>
              </tr>
              <tr>
                <td colSpan={5} className="p-0 border-0">
                  <Collapse in={expandedRow === log.id}>
                    <div>
                      <div className="bg-light p-3 m-2 rounded">
                        <small className="text-muted d-block mb-1">
                          <strong>Profile ID:</strong> {log.profile_id}
                        </small>
                        <small className="text-muted d-block mb-1">
                          <strong>User-Agent:</strong> {log.user_agent}
                        </small>
                        <small className="text-muted d-block mb-2">
                          <strong>Payload:</strong>
                        </small>
                        <pre
                          className="mb-0 p-2 bg-white rounded border"
                          style={{
                            maxHeight: '300px',
                            overflow: 'auto',
                            fontSize: '0.75rem',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all'
                          }}
                        >
                          {formatPayload(log.payload)}
                        </pre>
                      </div>
                    </div>
                  </Collapse>
                </td>
              </tr>
            </React.Fragment>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default AuditTable;
